import './ProductCategoryToggle'
import './ProductListing'
import './ProductImageGallery'
import './ProductSearch'
import './ProductRating'
import { SwalMessage, ToastMessage } from '../../Tools'

// ürün sayfa işlemleri
var Product = function () {

    var form;


    // Satın alım miktari düşüş/artış
    var Counter = function () {

        let counter = form.querySelector('.counter')
        let minusButton = counter.querySelector('[data-counter="minus"]')
        let plusButton = counter.querySelector('[data-counter="plus"]')
        let countInput = counter.querySelector('.count input')

        var count = parseInt(countInput.value);
        countInput.value = (!count || count < 1 || isNaN(count)) ? 1 : countInput.value


        // input keyup kontrolü
        $(countInput).on('keyup', function (event) {
            var count = parseInt(this.value);

            this.value = (!count || count <= 0) ? 1 : this.value
            if (count > parseInt(countInput.getAttribute('max'))) {
                this.value = countInput.getAttribute('max')
                plusButton.setAttribute('disabled', 'true')
                return;
            } else {
                plusButton.removeAttribute('disabled')
            }

            var key = window.event ? event.keyCode : event.which;
            if (event.keyCode === 9 || event.keyCode === 46) {
                return true;
            } else if (key < 49 || key > 57) {
                return false;
            } else {
                return true;
            }

        });

        // input change kontrolü
        $(countInput).on('change', function (event) {
            var count = parseInt(this.value);

            this.value = (!count || count <= 0) ? 1 : this.value
            if (count > parseInt(countInput.getAttribute('max'))) {
                this.value = countInput.getAttribute('max')
                plusButton.setAttribute('disabled', 'true')
                return;
            }

            var key = window.event ? event.keyCode : event.which;
            if (event.keyCode === 9 || event.keyCode === 46) {
                return true;
            } else if (key < 49 || key > 57) {
                return false;
            } else {
                return true;
            }
        })

        // miktar düşürme
        $(minusButton).on('click', function (event) {
            event.preventDefault();

            var count = parseInt(countInput.value);
            if (!count || count <= 0 || isNaN(count)) {
                countInput.value = 1;
            } else {
                countInput.value = (count > 1) ? count - 1 : countInput.value
            }
            plusButton.removeAttribute('disabled')
        })

        // miktar arttırma
        $(plusButton).on('click', function (event) {
            event.preventDefault();

            var count = parseInt(countInput.value);
            if (count + 1 > parseInt(countInput.getAttribute('max'))) {
                countInput.value = countInput.getAttribute('max')
                this.setAttribute('disabled', 'true')
                return;
            }
            countInput.value = (count > 0) ? count + 1 : countInput.value

        })

    }


    // Geri sayım
    var CountDown = function () {
        let timer = document.querySelector('.timer');
        if (!timer) {
            return;
        }

        var date = timer.getAttribute('data-date-value');

        var target_date = timeStamp(date);

        var days, hours, minutes, seconds;

        getCountdown();

        var countdownInterval = setInterval(function () {
            getCountdown();
        }, 1000);

        function getCountdown() {
            var current_date = new Date().getTime();
            var seconds_left = (target_date - current_date) / 1000;

            if (seconds_left <= 0) {
                // Sayaç sıfıra ulaştığında
                clearInterval(countdownInterval); // Interval'ı durdur
                location.reload(); // Sayfayı yenile
            } else {
                days = pad(parseInt(seconds_left / 86400));
                seconds_left = seconds_left % 86400;

                hours = pad(parseInt(seconds_left / 3600));
                seconds_left = seconds_left % 3600;

                minutes = pad(parseInt(seconds_left / 60));
                seconds = pad(parseInt(seconds_left % 60));

                timer.querySelector('[data-time="days"]').innerHTML = days;
                timer.querySelector('[data-time="hours"]').innerHTML = hours;
                timer.querySelector('[data-time="minutes"]').innerHTML = minutes;
                timer.querySelector('[data-time="seconds"]').innerHTML = seconds;
            }
        }

        function pad(n) {
            return (n < 10 ? '0' : '') + n;
        }

        function timeStamp(str) {
            // Format YYYY-MM-DDTHH:mm
            const [dateComponents, timeComponents] = str.split('T');
            const [year, month, day] = dateComponents.split('-');
            const [hours, minutes] = timeComponents.split(':');

            const date = new Date(+year, +month - 1, +day, +hours, +minutes);
            const timestamp = date.getTime();
            return timestamp;
        };
    }




    // Yorum
    var Comment = function () {

        let commentForm = form.querySelector('.comment-form')
        if (!commentForm) {
            return;
        }

        // yıldız oylama
        $(commentForm).on('click', '.stars .fa-star', function () {
            $('.stars .selected').each(function () {
                $(this).removeClass('selected');
            });
            $(this).addClass('selected');

            let voting = $(this).attr('data-voting')

            commentForm.querySelector('input[name="voting"]').value = voting
        });

        // form gönder
        $(commentForm).on('click', '[data-comment-submit]', function (event) {
            event.preventDefault();

            let formAction = commentForm.querySelector('form')

            $.ajax({
                url: apiUrl + '/CreateProductComment',
                type: "POST",
                dataType: "json",
                data: $(formAction).serialize(),
                error: function error(xhr) {
                    $(formAction).find('.invalid-feedback').empty();
                    $(formAction).find('*').removeClass('is-invalid');
                    $.each(xhr.responseJSON.errors, function (name, message) {

                        let element = formAction.querySelector('[name="' + name + '"]')

                        element.classList.add('is-invalid')

                        let valid = element.closest('div')
                            .querySelector('.invalid-feedback');
                        valid.style.display = 'block'
                        valid.innerHTML = message;

                    });
                },
                success: function success(xhr) {
                    SwalMessage(
                        {
                            type: 'success',
                            text: xhr.text ?? xhr.message,
                            confirmButton: translate.ok_button,
                        },
                        function () {
                            location.reload();
                        }
                    );
                }
            });


        })

    }


    // Takip Listesi
    var ProductTracking = function () {

        $(form).on('click', '[data-product-tracking]', function (event) {
            event.preventDefault();

            let thisButton = this;

            let productId = thisButton.getAttribute('data-product-id');
            let userId = thisButton.getAttribute('data-user-id');

            if (!userId) {
                ToastMessage('1', translate.product_tracking, translate.product_tracking_login)

                let button = document.querySelector('.auth-buttons');
                if (!button.querySelector('.dropdown-menu').classList.contains('show')) {
                    button.querySelector('.btn-auth').click()
                }

                return;
            }

            let data = {
                user_id: userId,
                product_id: productId,
            }

            $.ajax({
                url: apiUrl + '/UserProductTracking',
                type: "POST",
                dataType: "json",
                data: data,
                error: function error(xhr) {
                    //console.log(xhr);
                    ToastMessage('1', translate.product_tracking, xhr.responseJSON.text ?? xhr.responseJSON.message)
                },
                success: function success(xhr) {

                    if (xhr.row) {

                        thisButton.querySelector('svg').remove();
                        thisButton.insertAdjacentHTML('afterbegin', '<i class="fa-solid fa-bookmark text-main-color"></i>')

                        thisButton.querySelector('span').innerText = translate.product_tracking_remove;
                    } else {
                        thisButton.querySelector('svg').remove();
                        thisButton.insertAdjacentHTML('afterbegin', '<i class="fa-regular fa-bookmark"></i>')

                        thisButton.querySelector('span').innerText = translate.product_tracking_add;
                    }
                    ToastMessage('0', translate.product_tracking, xhr.text ?? xhr.message)
                }
            });

        })

    }

    // Beğeni Listesi
    var ProductLike = function () {

        $(form).on('click', '[data-product-like]', function (event) {
            event.preventDefault();

            let thisButton = this;

            let productId = thisButton.getAttribute('data-product-id');
            let userId = thisButton.getAttribute('data-user-id');

            if (!userId) {
                ToastMessage('1', translate.product_like, translate.product_like_login)

                let button = document.querySelector('.auth-buttons');
                if (!button.querySelector('.dropdown-menu').classList.contains('show')) {
                    button.querySelector('.btn-auth').click()
                }

                return;
            }

            let data = {
                user_id: userId,
                product_id: productId,
            }

            $.ajax({
                url: apiUrl + '/UserProductLike',
                type: "POST",
                dataType: "json",
                data: data,
                error: function error(xhr) {
                    ToastMessage('1', translate.product_like, xhr.responseJSON.text ?? xhr.responseJSON.message)
                },
                success: function success(xhr) {
                    if (xhr.row) {
                        thisButton.querySelector('svg').remove();
                        thisButton.insertAdjacentHTML('afterbegin', '<i class="fa-solid fa-heart text-main-color"></i>')

                        thisButton.querySelector('span').innerText = translate.product_like_remove;
                    } else {
                        thisButton.querySelector('svg').remove();
                        thisButton.insertAdjacentHTML('afterbegin', '<i class="fa-regular fa-heart"></i>')

                        thisButton.querySelector('span').innerText = translate.product_like_add;
                    }
                }
            });

        })

    }

    return {
        init: function () {
            form = document.querySelector('.product-page')
            if (form) {
                Counter();
                CountDown();
                Comment();
                ProductTracking();
                ProductLike();
            }

        },
    };

}();




$(function () {
    Product.init();
});